import { render } from "./NewMessageTemplatePreview.vue?vue&type=template&id=923ac1e6&scoped=true"
import script from "./NewMessageTemplatePreview.vue?vue&type=script&lang=js"
export * from "./NewMessageTemplatePreview.vue?vue&type=script&lang=js"

import "./NewMessageTemplatePreview.vue?vue&type=style&index=0&id=923ac1e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923ac1e6"]])

export default __exports__